module.exports = __webpack_public_path__ + "media/images/agentur_organisationsberatung_logo-03c9a2cdc76289dd477ab7ed87167f17.png";